import { Accordion, Card, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";


import * as moment from "moment";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import DataTable from "react-data-table-component";
import avatar1 from "../../../assets/images/avatars/01.png"
import ExpenseViewModal from "./ExpenseViewModal";

export default function ExpenseListOfUser({ expenses, expenseRefetch }) {
    const [expenseToDisplay, setExpenseToDisplay] = useState([]);
    const [search, setSearch] = useState("");
    const [text, setText] = useState({})
    const [showExpenseViewModal, setShowExpenseViewModal] = useState(false);
    const [selectedExpense, setSelectedExpense] = useState(null);

    const handleFilters = () => {
        setExpenseToDisplay(expenses.filter((item) => {
            if (search === "") return true;
            if (item.title.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.description.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.amount.toString().includes(search.toLowerCase())) {
                return true;
            } else if (item.userId?.length > 0 && item.userId[0].name.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.status.toLowerCase().startsWith(search.toLowerCase())) {
                return true;
            } else if (item.reviewedBy?.length > 0 && item.reviewedBy[0].name.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.reason.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (moment(item.createdAt).format("DD/MM/YY hh:mm").includes(search.toLowerCase())) {
                return true;
            }
            return false;
        }))
    }

    useEffect(() => {
        handleFilters();
    }, [search, expenses])

    const updateExpenseStatusMutation = useMutation((data) => axios.post(`${DEV_SERVER}/expense/v2/updateStatus/${data.id}`, data.body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            data = data.data;
            if (data.status) {
                toast.success(data.message);
                expenseRefetch()
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    let updateExpenseStatus = (id, status, reason) => {
        updateExpenseStatusMutation.mutate({ id, body: { status, reason } })
    }

    const columns = [
        {
            name: "Title",
            color: true,
            center: true,
            selector: "title",
        },
        {
            name: "Description",
            color: true,
            center: true,
            selector: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.description}</Tooltip>}><span>{row?.description}</span></OverlayTrigger>

            },
        },
        {
            name: "Amount",
            color: true,
            center: true,
            selector: "amount",
            cell: (row) => `₹ ${parseFloat(row?.amount).toFixed(2)}`,
            sortable: true,
        },
        {
            name: "Date",
            color: true,
            center: true,
            selector: "createdAt",
            cell: (row) => moment(row?.createdAt).format("DD/MM/YY hh:mm A"),
            sortable: true,
        },
        {
            name: "Media",
            color: true,
            center: true,
            selector: (row) => <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                {row?.media?.length > 0 && row?.media?.map((m) =>
                    <Zoom key={m._id}><img src={m.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", cursor: "pointer", width: "25px", height: "25px", borderRadius: "10px" }} /></Zoom>

                )}
            </div>
        },
        {
            name: "Status",
            color: true,
            center: true,
            selector: (row) => <span style={{ color: row?.status === "pending" ? "orange" : (row?.status === "approved" ? "green" : "red") }}>{row?.status}</span>
        },
        {
            name: "Reviewed By",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.reviewedBy?.length > 0) {
                    return row?.reviewedBy[0].name
                }
                return "NA"
            }
        },
        {
            name: "Reason",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.status === "pending") {
                    return <textarea style={{ width: "100%" }} value={text[row?.id] || ""} onChange={(e) => setText({ ...text, [row?.id]: e.target.value })} ></textarea>
                } else {
                    return row?.reason === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.reason}</Tooltip>}><span>{row?.reason}</span></OverlayTrigger>
                }
            }
        },
        {
            name: "Action",
            color: true,
            center: true,
            selector: (row) => <span style={{ display: "flex", alignItems: "center", justifyContent: "center", columnGap: "0.8rem", opacity: row?.status === "pending" ? 1 : 0.5 }}>
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Reject</Tooltip>}><i onClick={(e) => updateExpenseStatus(row?.id, "rejected", text[row?.id])} style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", color: "red" }} class="fas fa-times"></i></OverlayTrigger>
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Approve</Tooltip>}><i onClick={(e) => updateExpenseStatus(row?.id, "approved", text[row?.id])} style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", color: "green" }} class="fas fa-check"></i></OverlayTrigger>
            </span>
        },
        {
            name: "Location",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.location?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>View on Map</Tooltip>}><a href={`https://www.google.com/maps/search/?api=1&query=${row?.location[0]},${row?.location[1]}`} target="_blank" ><i class="fas fa-map-marker-alt"></i></a></OverlayTrigger>
                }
                return "NA"
            }
        }
    ]

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Expense List</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="mt-2" style={{ display: "flex", alignItems: "end", justifyContent: "flex-start", columnGap: "1rem", marginBottom: "1rem" }}>
                                    <div>
                                        <input type="search" id="search" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={search} onChange={(e) => setSearch(e.target.value)} />
                                    </div>
                                </div>
                                {<DataTable
                                    customStyles={
                                        {
                                            rows: {
                                                style: {
                                                    cursor: "pointer",
                                                    backgroundColor: "unset"
                                                }
                                            }
                                        }
                                    }
                                    onRowClicked={(row) => {
                                        setSelectedExpense(row);
                                        setShowExpenseViewModal(true);
                                    }} columns={columns} data={expenseToDisplay} pagination={true} />}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            {showExpenseViewModal && <ExpenseViewModal updateExpenseStatus={updateExpenseStatus} expense={selectedExpense} show={showExpenseViewModal} close={() => setShowExpenseViewModal(false)} />}
        </>
    )
}